var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserVerified = function SvgUserVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 10.7A3.85 3.85 0 1 0 12 3a3.85 3.85 0 0 0 0 7.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.808 13.643a1 1 0 0 1-.001 1.414l-5.87 5.86a1 1 0 0 1-1.414 0l-2.33-2.33a1 1 0 0 1 1.415-1.415l1.623 1.624 5.163-5.154a1 1 0 0 1 1.414.001",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.49 19.29c-.78-.78-.927-2.198-.147-2.979.78-.78 2.2-.78 2.98 0l.705.636 4.153-3.935c-1.32-1.19-2.69-1.881-4.6-1.881H10.4c-4.08 0-7.41 3.33-7.41 7.41v1.45h8.21l-.7-.7z"
  })));
};
export default SvgUserVerified;